// src/Reducers/ProductsReducer.js
import * as Types from '../Constants/AllConstants';

// Products paged
export const GetPagedProductsReducer = (state = { products: [], page: 0, pages: 0 }, action) => {
  switch (action.type) {
    case Types.PRODUCTS_PAGED_REQUEST:
      return { loading: true };
    case Types.PRODUCTS_PAGED_SUCCESS:
      return {
        loading: false,
        products: action.payload.content,
        page: action.payload.number,
        pages: action.payload.totalPages,
      };
    case Types.PRODUCTS_PAGED_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// All products (unpaged)
export const GetAllProductsReducer = (state = { products: [] }, action) => {
  switch (action.type) {
    case Types.PRODUCTS_ALL_REQUEST:
      return { loading: true, products: [] };
    case Types.PRODUCTS_ALL_SUCCESS:
      return { loading: false, products: action.payload };
    case Types.PRODUCTS_ALL_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Product details (admin or details)
export const ProductDetailsReducer = (state = { product: {} }, action) => {
  switch (action.type) {
    case Types.PRODUCT_DETAILS_REQUEST:
      return { loading: true };
    case Types.PRODUCT_DETAILS_SUCCESS:
      return { loading: false, product: action.payload };
    case Types.PRODUCT_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Create product
export const CreateProductReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PRODUCT_CREATE_REQUEST:
      return { loading: true };
    case Types.PRODUCT_CREATE_SUCCESS:
      return { loading: false, success: true, product: action.payload };
    case Types.PRODUCT_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PRODUCT_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Update product
export const UpdateProductReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PRODUCT_UPDATE_REQUEST:
      return { loading: true };
    case Types.PRODUCT_UPDATE_SUCCESS:
      return { loading: false, success: true, product: action.payload };
    case Types.PRODUCT_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PRODUCT_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// Delete product
export const DeleteProductReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PRODUCT_DELETE_REQUEST:
      return { loading: true };
    case Types.PRODUCT_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.PRODUCT_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Update product pricing
export const UpdateProductPricingReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PRODUCT_UPDATE_PRICING_REQUEST:
      return { loading: true };
    case Types.PRODUCT_UPDATE_PRICING_SUCCESS:
      return { loading: false, success: true, product: action.payload };
    case Types.PRODUCT_UPDATE_PRICING_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// IMAGES reducers
export const ProductImagesReducer = (state = { images: [] }, action) => {
  switch (action.type) {
    case Types.PRODUCT_IMAGES_REQUEST:
      return { loading: true, images: [] };
    case Types.PRODUCT_IMAGES_SUCCESS:
      return { loading: false, images: action.payload };
    case Types.PRODUCT_IMAGES_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const CreateProductImageReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PRODUCT_IMAGE_CREATE_REQUEST:
      return { loading: true };
    case Types.PRODUCT_IMAGE_CREATE_SUCCESS:
      return { loading: false, success: true, image: action.payload };
    case Types.PRODUCT_IMAGE_CREATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const UpdateProductImageReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PRODUCT_IMAGE_UPDATE_REQUEST:
      return { loading: true };
    case Types.PRODUCT_IMAGE_UPDATE_SUCCESS:
      return { loading: false, success: true, image: action.payload };
    case Types.PRODUCT_IMAGE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const DeleteProductImageReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PRODUCT_IMAGE_DELETE_REQUEST:
      return { loading: true };
    case Types.PRODUCT_IMAGE_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.PRODUCT_IMAGE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// VARIANTS reducers
export const ProductVariantsReducer = (state = { variants: [] }, action) => {
  switch (action.type) {
    case Types.PRODUCT_VARIANTS_REQUEST:
      return { loading: true, variants: [] };
    case Types.PRODUCT_VARIANTS_SUCCESS:
      return { loading: false, variants: action.payload };
    case Types.PRODUCT_VARIANTS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const CreateProductVariantReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PRODUCT_VARIANT_CREATE_REQUEST:
      return { loading: true };
    case Types.PRODUCT_VARIANT_CREATE_SUCCESS:
      return { loading: false, success: true, variant: action.payload };
    case Types.PRODUCT_VARIANT_CREATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const UpdateProductVariantReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PRODUCT_VARIANT_UPDATE_REQUEST:
      return { loading: true };
    case Types.PRODUCT_VARIANT_UPDATE_SUCCESS:
      return { loading: false, success: true, variant: action.payload };
    case Types.PRODUCT_VARIANT_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const DeleteProductVariantReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PRODUCT_VARIANT_DELETE_REQUEST:
      return { loading: true };
    case Types.PRODUCT_VARIANT_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.PRODUCT_VARIANT_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// PRICING RULES reducers
export const ProductPricingRulesReducer = (state = { pricingRules: [] }, action) => {
  switch (action.type) {
    case Types.PRODUCT_PRICING_RULES_REQUEST:
      return { loading: true, pricingRules: [] };
    case Types.PRODUCT_PRICING_RULES_SUCCESS:
      return { loading: false, pricingRules: action.payload };
    case Types.PRODUCT_PRICING_RULES_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const CreateProductPricingRuleReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PRODUCT_PRICING_RULE_CREATE_REQUEST:
      return { loading: true };
    case Types.PRODUCT_PRICING_RULE_CREATE_SUCCESS:
      return { loading: false, success: true, pricingRule: action.payload };
    case Types.PRODUCT_PRICING_RULE_CREATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const UpdateProductPricingRuleReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PRODUCT_PRICING_RULE_UPDATE_REQUEST:
      return { loading: true };
    case Types.PRODUCT_PRICING_RULE_UPDATE_SUCCESS:
      return { loading: false, success: true, pricingRule: action.payload };
    case Types.PRODUCT_PRICING_RULE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const DeleteProductPricingRuleReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PRODUCT_PRICING_RULE_DELETE_REQUEST:
      return { loading: true };
    case Types.PRODUCT_PRICING_RULE_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.PRODUCT_PRICING_RULE_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
